import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const clients_listing = async (
  client_type,
  source_slug,
  searchValue
) => {
  const requestObj = {
    path: `api/client/get_clients_by_client_type/${client_type}?search=${
      searchValue || ""
    }&source_slug=${source_slug}&limit=8`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const clients_types_api = async (
  page,
  limmit,
  Search,
  source_slug,
  sector,
  client_type
) => {
  const requestObj = {
    path: `api/client/all_clients_filtered?page=${page}&limit=${limmit}&search=${Search}&sector=${sector}&client_type=${client_type}&source_slug=${source_slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_client_details = async (id, sourceSlug = "") => {
  const requestObj = {
    path: `api/client/detail_client/${id}?source_slug=${sourceSlug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_client_feed_and_job = async (
  id,
  list_type = "",
  source_slug = "",
  page = 0,
  limit = 50,
  search = ""
) => {
  const requestObj = {
    path: `api/affiliation/get_affiliation_data/${id}?list_type=${list_type}&source_slug=${source_slug}&page=${page}&limit=${limit}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// Affiliate Flow

export const get_affiliated_client = async (id = "", response = "accepted") => {
  const requestObj = {
    path: `api/affiliation/get_affiliated_client/${id}?response=${response}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_affiliation_requests = async (
  id = "",
  page = 0,
  limit = 8,
  response = ""
) => {
  const requestObj = {
    path: `api/affiliation/receive_affiliation_request/${id}?response=${response}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_active_clients_list = async (
  search = "",
  page = 0,
  limit = 20,
  source = ""
) => {
  const requestObj = {
    path: `api/client/get_active_clients_list?source_slug=${source}&page=${page}&limit=${limit}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const send_affiliation_request = async (data) => {
  const requestObj = {
    path: `api/affiliation/send_affiliation_request`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_affiliation_request = async (data) => {
  const requestObj = {
    path: `api/affiliation/update_affiliation_request`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_affiliation_request = async (id) => {
  const requestObj = {
    path: `api/affiliation/delete_affiliation_data/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_my_affiliations = async (
  id,
  page = 0,
  limit = 8,
  response = ""
) => {
  const requestObj = {
    path: `api/affiliation/sended_affiliation_request/${id}?page=${page}&limit=${limit}&response=${response}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _upload_profile_media = async (data) => {
  const requestObj = {
    path: `api/client_assets/add_client_assets`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _get_profile_media = async (
  id,
  type = "media",
  page = 0,
  limit = 3
) => {
  const requestObj = {
    path: `api/client_assets/active_client_assets/${id}?type=${type}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _delete_client_media = async (id) => {
  const requestObj = {
    path: `api/client_assets/delete_client_assets/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
